import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createTempDashboard } from '@store/tempDashboard/actions';
import { DASHBOARD_TYPE, CURRENT_PRODUCT_MODE } from '@utils/constants';
import { getFilterFromRules } from '@utils';
import { StyledEllipsisTooltip, StyledFeedTitle, StyledLinkButton, StyledLinkCell } from './styled';
import { allDimensionsListSelector } from '@store/common/dimensionList/selectors';
import { ALL_TRAFFIC, createFilterRule } from '@utils/filter';
import { OUTLIER_METRICS, PRIORITY_MAPPING } from './utils';
import { supportedMetricsSelector } from '@store/common/selectors';
import { dimensionsSelector } from '@store/trends/base/selectors';
import Highlight from '@components/common/Highlight';
import { DEFAULT_DIMENSIONS } from '@store/trends/base/reducer';
import { getRuleDisplay } from '@src/utils/filter/getFilterFromRules';

const LinkTitleCell = ({ cellData, rowData, column }) => {
  const dispatch = useDispatch();
  const dimensionsData = rowData.dimensions;
  const dimensionsList = useSelector(allDimensionsListSelector);
  const trendsDimensions = useSelector(dimensionsSelector);
  const supportedMetrics: string[] = useSelector(supportedMetricsSelector);
  const cellDataArray: any[] = Object.entries(dimensionsData)[0]; // need to be extended when multiple dimensions are there
  const { searchText = '' } = column?.searchProps ?? {};
  const { icon } = PRIORITY_MAPPING[cellData];

  const openDashboard = (e) => {
    e.stopPropagation();
    const rules: any[] = [];
    const drilldownRules: any[] = []; // for breadcrumbs, passed to summaryContainer store
    // for multiple dimensions
    Object.entries(dimensionsData).forEach(([key, value]: [string, any], index) => {
      const dimensionObj = dimensionsList.find((d) => d.groupBy === key);
      const rule = createFilterRule(dimensionsList, dimensionObj.name, value.name, value.value);
      const ruleWithOrder = {
        ...rule,
        _order: index,
      };
      drilldownRules.push({
        name: getRuleDisplay(rule),
        presetFid: null,
        rule: [[ruleWithOrder]],
      });
      rules.push(ruleWithOrder);
    });
    const filter = getFilterFromRules(rules, true);

    const metrics = OUTLIER_METRICS.filter((m) => m in supportedMetrics);
    const dimensions = trendsDimensions.length
      ? trendsDimensions
      : DEFAULT_DIMENSIONS[CURRENT_PRODUCT_MODE];

    const { startTime: from, endTime: to } = rowData;
    const interval = {
      to,
      from,
      shortcut: 'custom',
      granularity: 'PT1H',
    };

    const dashboard = {
      metricsChartContainer: {
        metrics,
        metric: metrics[0],
      },
      common: {
        appliedFilters: [filter],
        interval,
      },
      summary: {
        drilldownData: [
          {
            name: ALL_TRAFFIC.name,
            rule: ALL_TRAFFIC.rule,
          },
          ...drilldownRules,
        ],
      },
      'module:trends': {
        base: {
          dimensions: [...new Set([cellDataArray[0], 'GEO_ISP', ...dimensions])],
          dimensionMetrics: metrics,
        },
      },
    };

    dispatch(createTempDashboard(DASHBOARD_TYPE.TRENDS_DRILLDOWN, dashboard, `${filter.name}`));
  };

  const dimension = dimensionsList.find((d) => d.groupBy === cellDataArray[0]);

  return (
    <StyledLinkCell>
      <div style={{ fontSize: 'larger', marginRight: '10px' }}>{icon}</div>
      <StyledFeedTitle>
        <StyledLinkButton onClick={openDashboard}>
          <StyledEllipsisTooltip tooltipText={cellDataArray[1].name}>
            <Highlight text={cellDataArray[1].name} highlight={searchText} />
          </StyledEllipsisTooltip>
        </StyledLinkButton>
        <div style={{ fontSize: '12px', opacity: 0.8 }}>
          <Highlight text={dimension ? dimension.name : cellDataArray[0]} highlight={searchText} />
        </div>
      </StyledFeedTitle>
    </StyledLinkCell>
  );
};
export default LinkTitleCell;
